import { Star, Zap, Shield, Clock } from "lucide-react";

// Интерфейс типа усиления
export interface PowerUpType {
  id: string;                                    // Уникальный идентификатор
  type: 'speed' | 'magnet' | 'shield' | 'time';  // Тип усиления
  x: number;                                     // Позиция по X
  y: number;                                     // Позиция по Y
  collected: boolean;                            // Флаг сбора
}

// Интерфейс пропсов компонента усиления
interface PowerUpProps {
  powerUp: PowerUpType;           // Данные усиления
  onCollect: (id: string) => void; // Функция сбора усиления
}

// Компонент иконки усиления в зависимости от типа
const PowerUpIcon = ({ type }: { type: PowerUpType['type'] }) => {
  switch (type) {
    case 'speed':   // Ускорение - молния
      return <Zap className="w-8 h-8 text-yellow-400" fill="currentColor" />;
    case 'magnet':  // Магнит - звезда
      return <Star className="w-8 h-8 text-purple-400" fill="currentColor" />;
    case 'shield':  // Щит - защита
      return <Shield className="w-8 h-8 text-blue-400" fill="currentColor" />;
    case 'time':    // Время - часы
      return <Clock className="w-8 h-8 text-green-400" fill="currentColor" />;
  }
};

// Основной компонент усиления
export const PowerUp = ({ powerUp, onCollect }: PowerUpProps) => {
  // Не отображаем уже собранные усиления
  if (powerUp.collected) return null;

  return (
    <div
      className="absolute cursor-pointer transition-all duration-300 hover:scale-110 animate-pulse"
      style={{ left: powerUp.x, top: powerUp.y }}
      onClick={() => onCollect(powerUp.id)}
    >
      <div className="relative">
        {/* Иконка усиления */}
        <PowerUpIcon type={powerUp.type} />
        {/* Светящийся эффект вокруг усиления */}
        <div className="absolute inset-0 w-8 h-8 bg-accent/20 rounded-full blur-sm animate-ping" />
      </div>
    </div>
  );
};